import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAlphabetsOnly]'
})
export class AlphabetsOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: KeyboardEvent): void {
    const initialValue = this.el.nativeElement.value;
    const newValue = initialValue.replace(/[^a-zA-Z\s]/g, '');
    this.el.nativeElement.value = newValue;
    if (initialValue !== newValue) {
      event.stopPropagation();
    }
  }
}
